// BillingItem.jsx
import React, { useState } from "react";
import { Table, Button, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { ModalUploadProvider } from "./ModalUploadProvider"; // Nuevo modal para subir fact. proveedor

export function BillingItem(props) {
  const { billing, isPartner } = props;
  const { t } = useTranslation("billing");
  const billingObj = billing.billings || {};
  const userObj = billingObj.user || {};

  // Para abrir/cerrar el modal de subir Factura Proveedor
  const [showModalUpload, setShowModalUpload] = useState(false);

  const handleDownload = (url) => {
    window.open(url, "_blank");
  };

  // Factura Cliente: sólo descarga
  const renderFacturaCliente = () => {
    if (!billingObj.billingdata) {
      return <span>{t("item.notAvailable")}</span>;
    } else {
      return (
        <Button
          size="mini"
          onClick={() => handleDownload(billingObj.billingdata)}
          title={t("item.downloadClientInvoice")}
        >
          <Icon name="download" />
          {t("item.downloadButton")}
        </Button>
      );
    }
  };

  // Factura Proveedor: solo partner la ve
  const renderFacturaProveedor = () => {
    if (!isPartner) return null;

    if (!billingObj.billingdatapartner) {
      // No hay => "No disponible" + Botón "Subir"
      return (
        <>
          <span>{t("item.notAvailable")}</span>{" "}
          <Button
            size="mini"
            onClick={() => setShowModalUpload(true)}
            title={t("item.uploadProviderInvoice")}
          >
            <Icon name="upload" /> {t("item.uploadButton")}
          </Button>
        </>
      );
    } else {
      // Hay => "Descargar" + Botón "Reemplazar"
      return (
        <>
          <Button
            size="mini"
            onClick={() => handleDownload(billingObj.billingdatapartner)}
            title={t("item.downloadProviderInvoice")}
          >
            <Icon name="download" />
            {t("item.downloadButton")}
          </Button>{" "}
          <Button
            size="mini"
            onClick={() => setShowModalUpload(true)}
            title={t("item.replaceProviderInvoice")}
          >
            <Icon name="upload" /> {t("item.uploadButton")}
          </Button>
        </>
      );
    }
  };

  // Fecha
  const dateFormatted = billingObj.created_at
    ? new Date(billingObj.created_at).toLocaleDateString("es-ES", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "N/A";

  return (
    <>
      <Table.Row>
        <Table.Cell>{userObj.role || "N/A"}</Table.Cell>
        <Table.Cell>
          {userObj.firstname} {userObj.lastname}
        </Table.Cell>
        <Table.Cell>{billingObj.billingNumber}</Table.Cell>
        <Table.Cell>{billingObj.description}</Table.Cell>
        <Table.Cell>{billingObj.billingtotal}</Table.Cell>

        {isPartner && <Table.Cell>{billingObj.billingpartner}</Table.Cell>}

        <Table.Cell>{billingObj.status}</Table.Cell>

        <Table.Cell>{renderFacturaCliente()}</Table.Cell>

        {isPartner && <Table.Cell>{renderFacturaProveedor()}</Table.Cell>}

        <Table.Cell>{dateFormatted}</Table.Cell>
      </Table.Row>

      {/* Modal para Subir Factura Proveedor */}
      {isPartner && (
        <ModalUploadProvider
          show={showModalUpload}
          onClose={() => setShowModalUpload(false)}
          billing={billing}
        />
      )}
    </>
  );
}
